var map = {
	"./assets/fonts/Inter-Black.otf": 5198,
	"./assets/fonts/Inter-Bold.otf": 9190,
	"./assets/fonts/Inter-ExtraBold.otf": 6588,
	"./assets/fonts/Inter-ExtraLight-BETA.otf": 4498,
	"./assets/fonts/Inter-Italic.otf": 8427,
	"./assets/fonts/Inter-Medium.otf": 522,
	"./assets/fonts/Inter-Regular.otf": 3255,
	"./assets/fonts/Inter-SemiBold.otf": 4180,
	"./assets/fonts/Inter-Thin-BETA.otf": 5379,
	"./assets/fonts/NeurialGrotesk-Bold.otf": 4597,
	"./assets/fonts/NeurialGrotesk-BoldItalic.otf": 2609,
	"./assets/fonts/NeurialGrotesk-Extrabold.otf": 5305,
	"./assets/fonts/NeurialGrotesk-ExtraboldItalic.otf": 2949,
	"./assets/fonts/NeurialGrotesk-Italic.otf": 1612,
	"./assets/fonts/NeurialGrotesk-Light.otf": 8142,
	"./assets/fonts/NeurialGrotesk-LightItalic.otf": 1754,
	"./assets/fonts/NeurialGrotesk-Medium.otf": 9621,
	"./assets/fonts/NeurialGrotesk-MediumItalic.otf": 6033,
	"./assets/fonts/NeurialGrotesk-Regular.otf": 7990,
	"./assets/icons/ESAWAS LOGO PNG-11 2.svg": 362,
	"./assets/icons/Layer_1-2.svg": 3951,
	"./assets/icons/Nawassco Logo (1) 1.svg": 3106,
	"./assets/icons/arrows.svg": 5945,
	"./assets/icons/bad.svg": 6580,
	"./assets/icons/bigmap.svg": 5339,
	"./assets/icons/calendar 01.svg": 2738,
	"./assets/icons/caution.svg": 3222,
	"./assets/icons/chart.svg": 3237,
	"./assets/icons/chat 01.svg": 2030,
	"./assets/icons/checkbox-control.svg": 9500,
	"./assets/icons/close.svg": 5837,
	"./assets/icons/comment-info.svg": 2471,
	"./assets/icons/compare.svg": 6384,
	"./assets/icons/compareicon.svg": 8219,
	"./assets/icons/delete.gif": 1719,
	"./assets/icons/document.svg": 152,
	"./assets/icons/done.svg": 6903,
	"./assets/icons/export.svg": 3205,
	"./assets/icons/exporticon.svg": 3826,
	"./assets/icons/good.svg": 2756,
	"./assets/icons/handshake.svg": 4942,
	"./assets/icons/information.svg": 3787,
	"./assets/icons/infra.svg": 5691,
	"./assets/icons/linkedlin.png": 997,
	"./assets/icons/list-active.svg": 6294,
	"./assets/icons/list.svg": 71,
	"./assets/icons/logo.svg": 6962,
	"./assets/icons/logpdaek.svg": 1348,
	"./assets/icons/mail.svg": 9814,
	"./assets/icons/map-active.svg": 3990,
	"./assets/icons/map.svg": 9543,
	"./assets/icons/menu.svg": 2434,
	"./assets/icons/messaging.svg": 1025,
	"./assets/icons/mouse.svg": 1688,
	"./assets/icons/newlogo.svg": 6766,
	"./assets/icons/notification.svg": 566,
	"./assets/icons/nwasco.svg": 2236,
	"./assets/icons/pending.svg": 7352,
	"./assets/icons/reset.svg": 7244,
	"./assets/icons/seemore.svg": 2791,
	"./assets/icons/twitter.svg": 8592,
	"./assets/icons/users-alt.svg": 3167,
	"./assets/icons/website.svg": 9386,
	"./assets/icons/wrong.svg": 550,
	"./assets/icons/youtube.svg": 2054,
	"./assets/images/abouthero.png": 9664,
	"./assets/images/bubbles.png": 8550,
	"./assets/images/chart1.png": 3954,
	"./assets/images/commercial.png": 925,
	"./assets/images/coursefive.png": 9228,
	"./assets/images/coursefour.png": 5084,
	"./assets/images/courseimg.png": 5279,
	"./assets/images/courseone.png": 3174,
	"./assets/images/coursesix.png": 7658,
	"./assets/images/coursethree.png": 5514,
	"./assets/images/coursetwo.png": 6344,
	"./assets/images/cybcourseimg.png": 3677,
	"./assets/images/datasciencecourse.png": 7558,
	"./assets/images/file-icon.png": 2223,
	"./assets/images/file-icon2.png": 2157,
	"./assets/images/financial.png": 2718,
	"./assets/images/footerlogo.png": 8007,
	"./assets/images/frame1.png": 7383,
	"./assets/images/frame2.png": 3452,
	"./assets/images/homehero.png": 3882,
	"./assets/images/institution.png": 6517,
	"./assets/images/layover.png": 1139,
	"./assets/images/leadfive.png": 2585,
	"./assets/images/leadfour.png": 9665,
	"./assets/images/leadone.png": 9577,
	"./assets/images/leadsix.png": 7009,
	"./assets/images/leadthree.png": 1537,
	"./assets/images/leadtwo.png": 3735,
	"./assets/images/map.png": 2313,
	"./assets/images/mapimg.png": 5140,
	"./assets/images/memberfour.png": 4797,
	"./assets/images/memberone.png": 7389,
	"./assets/images/memberthree.png": 1125,
	"./assets/images/membertwo.png": 2667,
	"./assets/images/serviceimg.png": 3797,
	"./assets/images/storyimg.png": 8543,
	"./assets/images/studentone.png": 8720,
	"./assets/images/studentthree.png": 8704,
	"./assets/images/studenttwo.png": 818,
	"./assets/images/successimgone.png": 4501,
	"./assets/images/successimgthree.png": 8589,
	"./assets/images/successimgtwo.png": 4819,
	"./assets/images/system.png": 8096,
	"./assets/images/tech1.png": 4938,
	"./assets/images/tech2.png": 1185,
	"./assets/images/tech3.png": 2792,
	"./assets/images/vlogo.png": 2540,
	"./assets/images/water-animation1.png": 5078,
	"./assets/images/webimg.png": 1180,
	"./assets/images/webinar.png": 9713,
	"./components/app/buttons": 7380,
	"./components/app/buttons.tsx": 7380,
	"./components/app/maincontainer": 7453,
	"./components/app/maincontainer.tsx": 7453,
	"./components/cards/additional-sections": 8813,
	"./components/cards/additional-sections.tsx": 8813,
	"./components/cards/card": 2027,
	"./components/cards/card.tsx": 2027,
	"./components/cards/centered-grid": 4601,
	"./components/cards/centered-grid.tsx": 4601,
	"./components/cards/centered-sections": 3392,
	"./components/cards/centered-sections.tsx": 3392,
	"./components/cards/contact-form": 7946,
	"./components/cards/contact-form.tsx": 7946,
	"./components/cards/course-card": 5679,
	"./components/cards/course-card.tsx": 5679,
	"./components/cards/courses-grid": 3058,
	"./components/cards/courses-grid.tsx": 3058,
	"./components/cards/cta-banner": 884,
	"./components/cards/cta-banner.tsx": 884,
	"./components/cards/download-brochure": 1568,
	"./components/cards/download-brochure.tsx": 1568,
	"./components/cards/enrollment-form": 5682,
	"./components/cards/enrollment-form.tsx": 5682,
	"./components/cards/faq-section": 8463,
	"./components/cards/faq-section.tsx": 8463,
	"./components/cards/global-presence": 6988,
	"./components/cards/global-presence.tsx": 6988,
	"./components/cards/left-aline": 5192,
	"./components/cards/left-aline.tsx": 5192,
	"./components/cards/left-elements": 2218,
	"./components/cards/left-elements.tsx": 2218,
	"./components/cards/left-sections": 1157,
	"./components/cards/left-sections.tsx": 1157,
	"./components/cards/map": 3591,
	"./components/cards/map.tsx": 3591,
	"./components/cards/our-story": 3755,
	"./components/cards/our-story.tsx": 3755,
	"./components/cards/sections": 1225,
	"./components/cards/sections.tsx": 1225,
	"./components/cards/testimonial": 3080,
	"./components/cards/testimonial.tsx": 3080,
	"./components/cards/title-banner": 7564,
	"./components/cards/title-banner.tsx": 7564,
	"./components/inputs/fileinput": 2213,
	"./components/inputs/fileinput.tsx": 2213,
	"./components/inputs/main": 4698,
	"./components/inputs/main.tsx": 4698,
	"./components/layouts/logo": 216,
	"./components/layouts/logo.tsx": 216,
	"./components/mobileaccess": 5485,
	"./components/mobileaccess.tsx": 5485,
	"./components/modals/donemodal": 8013,
	"./components/modals/donemodal.tsx": 8013,
	"./components/modals/infomodal": 6253,
	"./components/modals/infomodal.tsx": 6253,
	"./components/modals/modalcontainer": 8212,
	"./components/modals/modalcontainer.tsx": 8212,
	"./components/modals/select-tool": 9345,
	"./components/modals/select-tool.tsx": 9345,
	"./components/modals/selectregion": 8252,
	"./components/modals/selectregion.tsx": 8252,
	"./components/modals/selecttool": 314,
	"./components/modals/selecttool.tsx": 314,
	"./components/modals/sidemodalcontainer": 9601,
	"./components/modals/sidemodalcontainer.tsx": 9601,
	"./components/modals/startmaping": 2440,
	"./components/modals/startmaping.tsx": 2440,
	"./components/partials/box": 6689,
	"./components/partials/box.tsx": 6689,
	"./components/partials/buttons": 6445,
	"./components/partials/buttons.tsx": 6445,
	"./components/partials/footer": 6015,
	"./components/partials/footer.tsx": 6015,
	"./components/partials/header": 4345,
	"./components/partials/header.tsx": 4345,
	"./components/partials/inputs": 7499,
	"./components/partials/inputs.tsx": 7499,
	"./components/partials/printcomparetool": 2840,
	"./components/partials/printcomparetool.tsx": 2840,
	"./components/partials/tables": 2096,
	"./components/partials/tables.tsx": 2096,
	"./components/ui/button": 9772,
	"./components/ui/button.tsx": 9772,
	"./components/v-twelve/Hero": 382,
	"./components/v-twelve/Hero.tsx": 382,
	"./components/v-twelve/footer": 2671,
	"./components/v-twelve/footer.tsx": 2671,
	"./components/v-twelve/navbar": 4076,
	"./components/v-twelve/navbar.tsx": 4076,
	"./components/v-twelve/whatsapp-button": 3419,
	"./components/v-twelve/whatsapp-button.tsx": 3419,
	"./data/Config": 6835,
	"./data/Config.tsx": 6835,
	"./data/stores/authStore": 7445,
	"./data/stores/authStore.ts": 7445,
	"./data/stores/errorStore": 4167,
	"./data/stores/errorStore.ts": 4167,
	"./data/stores/loggerStore": 1131,
	"./data/stores/loggerStore.ts": 1131,
	"./data/useFetcher": 6106,
	"./data/useFetcher.tsx": 6106,
	"./screens/about": 3966,
	"./screens/about/": 3966,
	"./screens/about/index": 3966,
	"./screens/about/index.tsx": 3966,
	"./screens/compare-tools": 7642,
	"./screens/compare-tools/": 7642,
	"./screens/compare-tools/index": 7642,
	"./screens/compare-tools/index.tsx": 7642,
	"./screens/contact-us": 8162,
	"./screens/contact-us/": 8162,
	"./screens/contact-us/index": 8162,
	"./screens/contact-us/index.tsx": 8162,
	"./screens/dashboard": 6127,
	"./screens/dashboard/": 6127,
	"./screens/dashboard/index": 6127,
	"./screens/dashboard/index.tsx": 6127,
	"./screens/enroll-now": 768,
	"./screens/enroll-now/": 768,
	"./screens/enroll-now/index": 768,
	"./screens/enroll-now/index.tsx": 768,
	"./screens/home": 9859,
	"./screens/home/": 9859,
	"./screens/home/index": 9859,
	"./screens/home/index.tsx": 9859,
	"./screens/new-tool": 187,
	"./screens/new-tool/": 187,
	"./screens/new-tool/index": 187,
	"./screens/new-tool/index.tsx": 187,
	"./screens/our-courses": 8930,
	"./screens/our-courses/": 8930,
	"./screens/our-courses/index": 8930,
	"./screens/our-courses/index.tsx": 8930,
	"./screens/pdf": 2126,
	"./screens/pdf.tsx": 2126,
	"./utils/device": 2928,
	"./utils/device.ts": 2928,
	"./utils/types": 7721,
	"./utils/types.ts": 7721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6729;